import {Mechanics} from '../../../types/Mechanics';
import {hasNestedData} from './hasNestedData';

type BrakeLiningWear = NonNullable<Mechanics>['brake']['brakeLiningWear'];

export function hasBrakeLiningWearInfo(brakeLiningWear: BrakeLiningWear) {
  return hasNestedData(brakeLiningWear);
}
